import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-remove-group',
    templateUrl: './remove-group.component.html',
    styleUrls: ['./remove-group.component.scss'],
    standalone: false
})
export class RemoveGroupComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RemoveGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }
  cancel(){
    this.dialogRef.close(false);
  }
  removeMember() {
    this.dialogRef.close(true);
  }

}
